import { useStore } from '../core/store';
import { useEffect, useState } from 'react';
import { bookingTeaserConfig } from '../utils/teasers';

export const useBookingTeasers = () => {
  const { BookingStore } = useStore();

  const { data, status } = BookingStore.booking;

  const [config, setConfig] = useState([]);

  const flightsLength = BookingStore?.booking?.data?.flights?.length;

  const hotelsLength = BookingStore?.booking?.data?.hotels?.length;

  const hideTransfer = flightsLength === 0 || hotelsLength === 0;

  useEffect(() => {
    const nextConfig = [];

    if (data?.flights?.length || data?.returnFlights?.length) {
      nextConfig.push(bookingTeaserConfig.flight);
    }

    if (data?.hotels?.length) {
      nextConfig.push(bookingTeaserConfig.hotel);
    }

    if (data?.hasTransfer && !hideTransfer) {
      nextConfig.push(bookingTeaserConfig.transfer);
    }

    setConfig(nextConfig);
  }, [status]);

  return config;
};
